// extracted by mini-css-extract-plugin
module.exports = {"price":"styles_price__yNtwI","priceBeforeDiscount":"styles_priceBeforeDiscount__ayGXm","prices":"styles_prices__fkd0y"};